/** @KLUDGE Очередной костыль для конкурса */
export default function() {
  const theatreAdditionalFieldClass = '.theatre-kludge-field-block';
  const theatreAdditionalFieldsBlock = document.querySelector(theatreAdditionalFieldClass);

  if (!theatreAdditionalFieldsBlock) {
    return;
  }

  const theatreNominationsIds = [
    '1473',
    '1474',
    '1476',
    '1477',
    '1478',
    '1479',
    '1480'
  ];

  const nominationsInputs = document.querySelectorAll('.form__group input[name="category"]');

  // Сначала для не театральных номинаций при выборе убираем дополнительное театральное поле
  nominationsInputs?.forEach(function (input) {
    if (theatreNominationsIds.includes(input.value)) {
      return;
    }

    input.addEventListener('change', function () {
      if (this.checked) {
        theatreAdditionalFieldsBlock.classList.add('d-none');
      }
    });
  });

  nominationsInputs?.forEach(function (input) {
    // Пропускаем не театральные номинации
    if (!theatreNominationsIds.includes(input.value)) {
      return;
    }

    input.addEventListener('change', function () {
      if (this.checked) {
        theatreAdditionalFieldsBlock.classList.remove('d-none');
      }
    });
  });

  // После загрузки страницы возможно нет отмеченной номинации для этого случая
  // прячем дополнительное театральное поле
  let checkedTheatreNomination = false;
  nominationsInputs?.forEach(function (input) {
    if (
      theatreNominationsIds.includes(input.value) &&
      input.checked
    ) {
      checkedTheatreNomination = true;
    }
  });

  if (!checkedTheatreNomination) {
    theatreAdditionalFieldsBlock.classList.add('d-none');
  }
}